export default "__VITE_ASSET__DnWS_aDk__"